<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ddlHelper, sessionHelper, sharedHelper } from "@/utils";
import { SESSION } from "@/constants";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import i18n from '@/i18n'
import { LOOKUP_MODULE } from '@/state/modules/lookup'
import { PRODUT_MOA_MODULE } from '@/state/modules/productMoa'
import { lookupMethods, productMoaMethods } from "@/state/helpers";
import Multiselect from "vue-multiselect";

export default {
    page: {
        title: i18n.t("label.updateX", [i18n.t("module.productMoa")]),
    },
    components: { Layout, PageHeader, Multiselect },
    beforeRouteLeave(to, from, next) {
        if (to.name != "Product-moa-listing") {
            sessionHelper.clearSearch(SESSION.PRODUCT_MOA_SEARCH);
        }
        next();
    },
    computed: {
        ...mapState(PRODUT_MOA_MODULE, ["status"]),
        ...mapState(LOOKUP_MODULE),
        data() {
            return this.$store.state.productMoa.details;
        },
        productDdl() {
            return this.$store.state.lookup.productDdl;
        },
        moaDdl() {
            return this.$store.state.lookup.moaDdl;
        },
    },
    data() {
        return {
            title: i18n.t("label.createX", [i18n.t("module.productMoa")]),
            items: [
                {
                    text: i18n.t('module.dashboard'),
                    href: "/",
                },
                {
                    text: i18n.t("module.productMoa"),
                    href: "/product-moa",
                },
                {
                    text: i18n.t("label.createX", [i18n.t("module.productMoa")]),
                    active: true,
                },
            ],
            submitted: false,
            statusDdl: ddlHelper.getActivationStatus(false, true),
            selectedOffDays: [], // This will hold the full objects selected in the multiselect
            weekDayDdl: ddlHelper.getWeekDays(),
            permissions: sessionHelper.getPermissions(),
            createPermission: null,
            isCloseWhenSuccess: false,
            createForm: {
                moaID: "",
                productID: "",
            },
        };
    },
    validations: {
        createForm: {
            productID: { required },
            moaID: { required },
        },
    },
    async created() {
        await this.validPermissions();
        this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PRODUCT_SPECIAL_SEARCH);
        await this.lookupProduct({ hasOptionAll: false });
        await this.lookupMOA({ hasOptionAll: false });

        if (this.searchCriteria != null && this.searchCriteria != '') {
            this.createForm.productID = this.$store.state.lookup.productDdl.filter(item => item.value === this.searchCriteria.selectedRecordId);
            this.isCloseWhenSuccess = true;

            if (this.searchCriteria != null && this.searchCriteria != '' && this.searchCriteria.selectedRecordId == null) {
                sharedHelper.alertErrorMessageWithoutCode("Invalid Product ID, Please Contact Admin")
            }
        }
    },
    methods: {
        ...productMoaMethods,
        ...lookupMethods,
        async validPermissions() {
            var jsonPermissions = JSON.parse(this.permissions)
            if (jsonPermissions.some(p => p.code === "RND_MOA_MOAC")) {
                this.createPermission = true;
            }
            else {
                this.createPermission = false;
            }
        },
        async requestCreate() {
            this.submitted = true;
            // stop here if form is invalid
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            } else {
                let isCloseWhenSuccess = this.isCloseWhenSuccess;
                let data = {
                    moaID: this.createForm.moaID.value,
                    productID: this.isCloseWhenSuccess == true ? this.createForm.productID[0].value : this.createForm.productID.value,
                };

                if (this.createPermission == true) {
                    await this.createProductMoa({ data, isCloseWhenSuccess });
                }
            }
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <form @submit.prevent="requestCreate" v-if="createPermission == true">
                            <div class="row">
                               
                                <div class="col-md-6">
                                    <b-form-group id="productID" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('module.product')" label-for="productID">
                                        <multiselect v-model="createForm.productID"
                                            deselect-label="Can't remove this value" track-by="value" label="text"
                                            placeholder="Select one" :options="productDdl" :searchable="true"
                                            :allow-empty="false">
                                        </multiselect>
                                        <div v-if="submitted && !$v.createForm.productID.required"
                                            class="invalid-feedback" style="display: block;">
                                            <span>{{ $t("message.requiredX", [$t("module.product")]) }}</span>
                                        </div>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group id="moaID" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('module.moa')" label-for="moaID">
                                        <multiselect v-model="createForm.moaID"
                                            deselect-label="Can't remove this value" track-by="value" label="text"
                                            placeholder="Select one" :options="moaDdl" :searchable="true"
                                            :allow-empty="false">
                                        </multiselect>
                                        <div v-if="submitted && !$v.createForm.moaID.required"
                                            class="invalid-feedback" style="display: block;">
                                            <span>{{ $t("message.requiredX", [$t("module.moa")]) }}</span>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>

                            <div class="mt-4 text-center" style="float: right">
                                <button class="btn btn-primary w-md waves-effect waves-light" style="margin-right: 10px"
                                    type="submit" :disabled="status.create">
                                    {{ $t("label.createX", [$t("module.productMoa")]) }}
                                </button>
                            </div>
                        </form>
                        <div style="text-align: center;" v-else>
                            {{ $t('message.noPermissionMessage') }}
                        </div>
                    </div>
                </div>
                <!-- end card -->
            </div>
            <!-- end col -->
        </div>
    </Layout>
</template>